import PropTypes from 'prop-types';
import CommentTextField from 'apps/interactions/form/fields/comment-text-field';
import InteractionTypeField from 'apps/interactions/form/fields/shared-fields/interaction-type-field';
import { DynamicField } from '@evertrue/sdk';
import { useInteractionFormContext } from 'apps/interactions/form/context/interaction-form-context';

const CommentBody = ({ values, contactId, requestHide = () => {}, isPinned = false }) => {
  const { hasInteractionWrites } = useInteractionFormContext();

  return (
    <>
      <DynamicField
        name="interaction_type"
        label="Interaction Type"
        values={{ ...values, has_interaction_writes: hasInteractionWrites }}
        as={InteractionTypeField}
      />
      <DynamicField
        name="text"
        label="Description"
        values={values}
        component={CommentTextField} // Note: using "component" prop instead of "as" prop. See difference in Formik Docs.
        wrap={false}
        // These props are required by the CommentTextField component
        contactId={contactId}
        onClose={requestHide}
        isPinned={isPinned}
      />
    </>
  );
};

CommentBody.propTypes = {
  values: PropTypes.object.isRequired,
  contactId: PropTypes.number,
  requestHide: PropTypes.func,
  isPinned: PropTypes.bool,
};

export default CommentBody;
